//
// NetworkRequestContent.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";
import "../../models/BaseModel";
import "../../models/particles/CharacterSet";

var NetworkRequestContent = createModule("commons::NetworkRequestContent", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    ,
    {
        charset: 4,
        contentType: 7,
        contentBody: 7,
        partName: 7,
    },
    ,
    ,
    {
        getContentTypeValue: [7],
        getContentTypeHeader: [7],
        updateFromContentTypeValue: [0,7],
    },
    {
        _create_v: [4],
        _create_s: [4,7],
        _create_ssns: [4,7,7,4,7],
        _create_ssn: [4,7,7,4],
        _create_ss: [4,7,7],
    },
    ,
    ["_create"]
]);
export default NetworkRequestContent;
